export const POLICY_TEMPLATES = [
    {
        name: 'Basic Document Access',
        description: 'Allow users to read documents they own or public documents',
        yaml: `apiVersion: api.cerbos.dev/v1
kind: PrincipalPolicy
version: "1.0"
principals:
  - user
rules:
  - resource: document
    actions:
      - name: read
        condition:
          match:
            any:
              - expr: resource.attr.visibility == "public"
              - expr: resource.attr.owner == principal.id`
    },
    {
        name: 'Role-Based Access',
        description: 'Different permissions based on user roles',
        yaml: `apiVersion: api.cerbos.dev/v1
kind: ResourcePolicy
version: "1.0"
resource: document
rules:
  - roles: ["admin"]
    actions: ["*"]
    effect: ALLOW
  - roles: ["manager"]
    actions: ["read", "write"]
    effect: ALLOW
  - roles: ["user"]
    actions: ["read"]
    effect: ALLOW
    condition:
      match:
        any:
          - expr: resource.attr.visibility == "public"
          - expr: resource.attr.owner == principal.id`
    },
    {
        name: 'Tenant Isolation',
        description: 'Ensure users can only access resources in their tenant',
        yaml: `apiVersion: api.cerbos.dev/v1
kind: ResourcePolicy
version: "1.0"
resource: "*"
rules:
  - roles: ["*"]
    actions: ["*"]
    effect: DENY
    condition:
      match:
        expr: resource.attr.tenant_id != principal.attr.tenant_id
  - roles: ["*"]
    actions: ["*"]
    effect: ALLOW
    condition:
      match:
        expr: resource.attr.tenant_id == principal.attr.tenant_id`
    }
];
